.tag {
  display: flex;
  gap: 0.25rem;
  align-items: center;
  justify-content: space-between;
  height: 22px;
  padding: 0 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--primary-dark);
  background-color: var(--primary-100);
  border-radius: 2px;
  transform: translateY(1px);
}

.text {
  transform: translateY(1px);
}

.close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(22px + 0.25rem);
  height: 100%;
  padding: 0;
  color: var(--primary-dark);

  &:hover {
    background-color: var(--primary-light);
  }
}
